import { each, filter, isEmpty, noop } from 'lodash/fp';
import { WebsocketMessageType } from '@mews-commander/enums';
import { createHandler } from '@mews/std';
import { logError, redirectToSignIn } from '../../modules/app/actions/common';
import { reportError } from '../logger/actions';
import { disconnectFromWebsocket } from './actions';

export default function createMessageHandler(eventHandlers: $TSFixMe) {
    return createHandler(
        {
            [WebsocketMessageType.Unauthorized]: (payload, { dispatch }) => {
                dispatch(
                    logError({
                        type: 'force-reload',
                        message: 'Sign out caused by unauthorized websocket message.',
                    })
                );
                dispatch(disconnectFromWebsocket());
                dispatch(redirectToSignIn());
            },

            [WebsocketMessageType.Error]: (message, { dispatch }) => {
                dispatch(reportError(message));
            },

            [WebsocketMessageType.Events]: (message, { dispatch, getState }) => {
                each((handler) => {
                    handleEvents(handler.type, message.events, (filtered: $TSFixMe) =>
                        handler.handle(dispatch, getState, filtered)
                    );
                }, eventHandlers);
            },
        },
        noop
    );
}

function handleEvents(type: $TSFixMe, events: $TSFixMe, handle: $TSFixMe) {
    const filtered = filter({ type: type.name }, events);

    if (!isEmpty(filtered)) {
        handle(filtered);
    }
}
